import { getSiteIdsForGroups } from "@/utils/store";

const DEFAULT_STATE = {
  sites: [],
  siteGroups: [],
  dates: [],
  data: [],
  categories: [],
  periodType: "articles_seen",
  globalData: {
    total: 0,
    multi_repub: 0,
    ca: 0,
    ca_before: 0,
    ca_after: 0,
    ca_percent: 0,
    ca_period: 0,
    sessions: 0,
    sessions_before: 0,
    sessions_after: 0,
    sessions_percent: 0,
    sessions_period: 0,
  },
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getSites: (state) => state.sites,
    getSiteGroups: (state) => state.siteGroups,
    getDates: (state) => {
      // always return the dates ordered
      return state.dates[0] < state.dates[1]
        ? [state.dates[0], state.dates[1]]
        : [state.dates[1], state.dates[0]];
    },
    getData: (state) => state.data,
    getCategories: (state) => state.categories,
    getPeriodType: (state) => state.periodType,
    getGlobalData: (state) => state.globalData,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setSiteGroups(state, payload) {
      state.siteGroups = payload;
    },
    setDates(state, payload) {
      state.dates = payload;
    },
    setData(state, payload) {
      state.data = payload;
    },
    setCategories(state, payload) {
      state.categories = payload;
    },
    setPeriodType(state, payload) {
      state.periodType = payload;
    },
    setGlobalData(state, payload) {
      state.globalData = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
    async updateSiteGroups({ commit }, payload) {
      commit("setSiteGroups", payload);

      const site_ids = await getSiteIdsForGroups(payload);
      commit("setSites", site_ids);

      return site_ids;
    },
    updateDates({ commit }, payload) {
      if (payload.length >= 2) {
        commit("setDates", payload);
      }
    },
    updateData({ commit }, payload) {
      commit("setData", payload);
    },
    updateCategories({ commit }, payload) {
      commit("setCategories", payload);
    },
    updatePeriodType({ commit }, payload) {
      commit("setPeriodType", payload);
    },
    updateGlobalData({ commit }, payload) {
      commit("setGlobalData", payload);
    },
  },
};
